<template>
  <div class="rightBottomAll">
    <div class="top">
		<!-- <span>{{stationName}}</span> -->
		<span>广州白云机场站</span>
	</div>
    <div class="bottom">
      <div class="bottom-left">
		  <xunidianchangBottomLeft></xunidianchangBottomLeft>
	  </div>
      <div class="bottom-right">
        <div class="notice-box">
          <!-- <div class="notice-box-title">需求响应</div> -->
			  <div class="notice-box-cell " 
			  v-for="(item, i) in target" :key="'target' + i">
				{{ item.label }} <br /><span class="number">{{ item.number }}</span>
				<span class="unit">{{ item.unit }}</span>
			  </div>
		 
        </div>
		<div class="bottom-right-bottom">
			<div class="tiaojiefuhe">
				<tiaojiefuhe></tiaojiefuhe>
			</div>
			<div class="tiaojiexiaolv">
				<tiaojiexiaolv></tiaojiexiaolv>
			</div>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
	
import { dataInterface } from "@/api/dataInterfaceApi";
import tiaojiefuhe from "./tiaojiefuhe.vue";
import tiaojiexiaolv from "./tiaojiexiaolv.vue";
import xunidianchangBottomLeft from "./xunidianchangBottomLeft.vue";
export default {
  components: {
	  tiaojiexiaolv,
	  tiaojiefuhe,
	  xunidianchangBottomLeft
  },
  data() {
    let mIcon = require("@/assets/images/exposition/juheshang.png");
    return {
      photovoltaic: {},
      now: "日",
      target: [
        {
          icon: mIcon,
          label: "参与次数",
          number: "33",
          unit: "次",
        },
        {
          icon: mIcon,
          label: "累计响应",
          number: "39.0",
          unit: "MWh",
        },
        {
          icon: mIcon,
          label: "综合单价",
          number: "1.56",
          unit: "元/kWh",
        },
        {
          icon: mIcon,
          label: "指令成功率",
          number: "98",
          unit: "%",
        },
        {
          icon: mIcon,
          label: "有效调节率",
          number: "98",
          unit: "%",
        },
      ],
	  stationName:"",
      province: "32",
      show1: false,
      show2: false,
    };
  },
  destroyed() {
    this.$bus.$off("updateDummyFn");
  },
  mounted() {
    this.$bus.$on("updateDummyFn", () => {
		// console.log(99776666)
      this.getphotovoltaic();
    });
    // this.getphotovoltaic();
    // this.getData();
  },
  methods: {
    nowType() {
      return localStorage.getItem("typeTime") || "日";
    },
    getphotovoltaic() {
      this.show1 = false;
	  this.stationName = localStorage.getItem("dummySattionName");
      let params = {
        enCode: "powerplant-right-hdzljzb",
        "@station_id": localStorage.getItem("dummySattionId") ? localStorage.getItem("dummySattionId") : '0217fb691abe4b3abb5adb4ed72b590b'
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          // console.log(res, "响应主体分布111111");
          let data = res[0] || {};
          this.target[0].number = Math.trunc(data.participate_num) || 0;
          this.target[1].number = data.acc_response || 0;
          this.target[2].number = data.unit_price || 0;
          this.target[3].number = data.success_rate || 0;
          this.target[4].number = data.regulation_rate || 0;
          this.show1 = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./comm.scss";
@font-face {
  font-family: "DS-Digital-Bold";
  src: url("~@/assets/font/DS-Digital-Bold.ttf");
}
.DS-Digital-Bold {
  font-family: "DS-Digital-Bold";
}
.rightBottomAll{
	position: absolute;
	right: 70px;
	top: 0px;
	background: url("~@/assets/images/exposition/xunidianchang-rightBottomAll.png") no-repeat;
	 background-size: 100% 100%;
	height: 830px;
	width: 2142px;
	.top {
	  height: 104px;
	  width: 100%;
	  // line-height: 114px;
	  text-align: center;
	  // background-color: rgb(180, 238, 86);
	  span{
		  letter-spacing:3px;
		  display: block;
		  padding-top: 26px;
		  font-size: $FontSize48;
		  font-weight: bold;
	  }
	}
	.bottom {
	  height: 668px;
	  width: 100%;
	  margin-left: 12px;
	  // background-color: rgb(241, 147, 116);
	  display: flex;
	  .bottom-left {
	    width: 764px;
	    height: 668px;
		// display: flex;
		.bottom-left-top{
			width: 764px;
			height:  169.6px;
			display: flex;
		}
	  }
	  .bottom-right {
	    width: 1364px;
	    height: 668px;
		margin-left: 20px;
	    // background-color: rgb(114, 144, 158);
		// display: flex;
			.notice-box {
			  margin-right: 15px;
			  width: 1324px;
			  // width: 100%;
			  height: 145px;
			  margin-top: 20px;
			  // margin-bottom: 20px;
			  //   margin-left: 70px;
			  background: url("~@/assets/images/exposition/xunidianchang-xuqiuxiangyingbiao.png") no-repeat;
			  background-size: 100% 100%;
			  font-size: $FontSize36;
			  padding-left: 160px;
			  display: flex;
				  .notice-box-title {
					width: 190px;
					line-height: 129px;
					// background-color: pink;
					text-align: center;
					padding-right: 10px;
				  }
			
				  .notice-box-cell {
					width: 270px;
					// text-align: center;
					font-size:$FontSize24;
					margin-top: 30px;
					padding: 0 10px 0 50px;
					background: url("~@/assets/images/exposition/link.png") no-repeat;
					background-size: 23px 45px;
					background-position: 20px 8px;
				  }
				   .number{
					   font-size: $FontSize32;
					   color: #00FDF4;
				   }
				   .unit{
					   font-size: $FontSize32;
				  	color: #00FDF4;
				    }
			}
			.bottom-right-bottom{
				// flex: 1;
				width: 1364px ;
				height: 503px;
				display: flex;
				// height: 100px;
				.tiaojiefuhe{
					width: 672px;
					height: 503px;
					// background-color: yellow;
				}
				.tiaojiexiaolv{
					width: 672px;
					height: 503px;
					// background-color: red;
				}
			}
	  }
	}
}

</style>

